import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ThemeProvider } from 'styled-components';
import { KindredIcon } from '../../Common/Icons';
import { themeColor } from '../../Theming';
import PostActivationSlide from './PostActivationSlide';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 1rem 1.5rem;

  & > #description {
    text-align: center;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const AllDone = styled.p`
  color: ${themeColor('black')};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: -5px;
`;

const SaveWhileDoingGood = styled.p`
  color: ${themeColor('black')};
  font-size: 13px;
  max-width: 275px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

const ExperienceSavings = styled.p`
  color: ${themeColor('black')};
  font-size: 19px;
  font-weight: bold;
  max-width: 275px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 25px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -20px;
`;

const imageStyle = { width: 59, height: 59 };

const PostActivationPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <div id="beforeLogo">
        <p></p>
      </div>
      <LogoContainer id="logo">
        <KindredIcon style={imageStyle} color="discounts_and_savings" />
      </LogoContainer>
      <div id="afterLogo">
        <p></p>
      </div>
      <div id="beforeDescription">
        <p></p>
      </div>
      <ContentContainer id="description">
        <AllDone>{t('samsung.activation.allDone')}</AllDone>
        <SaveWhileDoingGood>
          {t('samsung.activation.saveWhileDoingGood')}
        </SaveWhileDoingGood>
        <PostActivationSlide />
        <ExperienceSavings>
          {t('samsung.activation.experienceSavings')}
        </ExperienceSavings>
      </ContentContainer>
      <div id="afterDescription">
        <p></p>
      </div>
    </Container>
  );
};

export default PostActivationPage;
